/* eslint-disable react/prop-types */
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { Component } from "react";
import Tooltip from "@react/react-spectrum/Tooltip";
import PropTypes from "prop-types";
import OverlayTrigger from "@react/react-spectrum/OverlayTrigger";
import { TOOLTIP } from "../Constants/constants";

const withToolTip = WrappedComponent => {
  class WithToolTip extends Component {
    getTooltipWithShortCut = (text, shortCut) =>
      shortCut ? `${text} (${shortCut})` : text;

    render() {
      const {
        tooltip: {
          text,
          shortcut,
          placement,
          delay,
          trigger,
          className = "",
          variant,
          show
        } = {}
      } = this.props;
      const tooltipString = this.getTooltipWithShortCut(text, shortcut);

      if (!text)
        return <WrappedComponent {...this.props} data-testid={tooltipString} />;

      // <div> wraps required - currently overlay trigger does not work with dynamic ele like WrapperComponent
      return (
        <div>
          <OverlayTrigger
            delayShow={delay || TOOLTIP.DELAY}
            placement={placement}
            data-testid={tooltipString}
            trigger={trigger}
            show={show}
          >
            <div>
              <WrappedComponent {...this.props} />
            </div>
            <Tooltip
              variant={variant}
              className={className}
              style={{ wordWrap: "break-word" }}
            >
              {tooltipString}
            </Tooltip>
          </OverlayTrigger>
        </div>
      );
    }
  }

  WithToolTip.propTypes = {
    tooltip: PropTypes.objectOf({
      text: PropTypes.string,
      shortcut: PropTypes.string,
      placement: PropTypes.oneOf(TOOLTIP.PLACEMENT),
      delay: PropTypes.number,
      className: PropTypes.string
    })
  };

  WithToolTip.defaultProps = {
    tooltip: {}
  };

  return WithToolTip;
};

export default withToolTip;
